import { createFileRoute } from "@tanstack/react-router"
import { MyProfilePage } from "@/myprofiles"

// The myprofiles_ prefix un-nests this route from myprofiles.tsx (the
// list is a page, not a layout); the URL stays /myprofiles/$assignmentId
export const Route = createFileRoute("/(user)/myprofiles_/$assignmentId")({
  component: RouteComponent,
})

function RouteComponent() {
  const { assignmentId } = Route.useParams()

  return <MyProfilePage assignmentId={assignmentId} />
}
